module.exports = __webpack_public_path__ + "static/media/symbol_clone.1db17346.svg";